/**
 * lib/ga.js — Google Analytics 4 (chargement conditionnel au consentement RGPD)
 * Module Bourse d'Idées — utilise REACT_APP_GA_MEASUREMENT_ID (Create React App)
 */

export const CONSENT_KEY = 'innov360_bourse_cookie_consent';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initGA() {
  if (!GA_ID || initialized || typeof document === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: true });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    initialized = true;
  } catch { /* silencieux */ }
}

export function loadGAIfConsented() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return;
    const consent = JSON.parse(raw);
    if (consent?.analytics === true) initGA();
  } catch { /* silencieux */ }
}

export function gaEvent(eventName, params = {}) {
  if (!initialized || typeof window.gtag !== 'function') return;
  try { window.gtag('event', eventName, params); } catch { /* silencieux */ }
}
